<template>
  <Portal to="popup">
    <Photo @close="redirect"></Photo>
  </Portal>
</template>

<script>
import Photo from "./Photo";
export default {
  name: "PopupRouterView",
  components: {
    Photo
  },
  methods: {
    redirect(artist) {
      this.$router.push(`/artists/${artist}`);
    }
  }
};
</script>
